// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes loading-4ba6d163{to{transform:translateX(100%)}}.loading[data-v-4ba6d163]:after,.loading[data-v-4ba6d163]:before{bottom:0;content:\"\";height:100%;left:0;position:absolute;right:0;top:0;z-index:1}.loading[data-v-4ba6d163]:before{background:var(--cp-gray-6)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
